export default "__VITE_ASSET__BrEMhcHL__"